import { theme } from 'react-components'
import styled from 'styled-components'

export const PaginationIcon = styled.div`
    width: 12px;
    height: 12px;
    display: flex;
    align-items: center;
    justify-content: center;

    svg {
        width: 100%;
        height: 100%;
        fill: currentColor;
        path {
            fill: currentColor;
        }
    }
`

export const PaginationWrapper = styled.div`
    display: flex;
    justify-content: center;
    gap: 8px;
    margin-top: 24px;
`

export const PaginationDots = styled.span`
    padding: 0 10px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
`

export const PageButton = styled.button<{ active?: boolean }>`
    padding: 6px 12px;
    border-radius: 6px;
    border: 1px solid ${({ active, theme }) => (active ? theme.colors.black : theme.colors.tfwBlack38)};
    background-color: ${({ active, theme }) => (active ? theme.colors.black : theme.colors.white)};
    color: ${({ active, theme }) => (active ? theme.colors.white : theme.colors.black)};
    cursor: pointer;
    min-width: 36px;
    transition: 0.2s ease;

    &:hover {
        border-color: ${theme.colors.black};
    }
    &:disabled {
        cursor: not-allowed;
        opacity: 0.4;
        background-color: ${theme.colors.tfwBlack3};
        border-color: ${theme.colors.tfwBlack38};
        color: ${theme.colors.tfwBlack38};
        pointer-events: none;

        svg {
            fill: ${theme.colors.tfwBlack45};
            opacity: 0.5;
        }
    }
`
